/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Sync_Changes_Status_ProgressInputs */



/**
* | output |
* | --- |
* | "Syncing event {current}/{total}" |
*
* @param {Sync_Changes_Status_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_status_progress = /** @type {((inputs: Sync_Changes_Status_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Status_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Synchronisation de l'evenement ${i?.current}/${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Synchronisierungsereignis ${i?.current}/${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sincronizzazione evento ${i?.current}/${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Синхронизация события ${i?.current}/${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento de sincronización ${i?.current}/${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`同步事件 ${i?.current}/${i?.total}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.current}/${i?.total} を同期しています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सिंक्रोनाइज़िंग इवेंट ${i?.current}/${i?.total}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Sincronizando evento ${i?.current}/${i?.total}`)
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
});